<div class="tw-flex tw-justify-center tw-items-center" *ngIf="currentTrend || trendSelected">
  <h3 class="tw-font-rubik tw-font-medium tw-text-base tw-text-black tw-ml-4" style="font-weight: 500; font-size: 16px;">
    {{ (currentTrend ? (prefixTranslateFilters + '.' + currentTrend.value) : (prefixTranslateFilters + '.' + trendSelected)) | translate }}
  </h3>
</div>

<div *ngIf="showFilters">
  <div class="row align-items-center row-filters" [class.none]="lists.trend.length===0" *ngIf="!waiting && lineChartData.length>1">
    <div class="col-6" *ngIf="showOtherFilters">
      <ng-container *ngIf="!currentTrend">
        <ng-container *ngFor="let key of ['trend','areas']">
          <div class="inline list-metric" *ngIf="lists[key].length>0">
            <widget-list-options
              [labelAction]="('commons.select_one_variable' | translate )"
              [name]="'wdiget.trends.'+key"
              [list]="lists[key]"
              [selected]="key === 'trend' ? trendSelected : areaSelected"
              [viewType]="'button'"
              [prefixTranslate]="(key==='segmentedBy' ? 'commons' : (key==='areas' ? 'areas' : prefixTranslateFilters))"
              (select)="setSelectlValue($event,key)">
            </widget-list-options>
          </div>
        </ng-container>
      </ng-container>
    </div>

    <div class="col-12 filter-customer tw-pt-[30px] tw-pb-[20px]" *ngIf="(chain.length>2 || !showDefaultLegends) && lineChartData.length>1">
      <widgets-trends-legend
        [showAccordion]="false"
        (filterCustomerChange)="filterCustomers($event)"
        [lineChartData]="lineChartData"
        [lineChartColors]="lineChartColors"
        [displayBtn]="(!showOtherFilters) ? 'show-left' : ''"
        [browserLabel]="this.isCorporative ? 'interchain-dashboard.search_hotel' : 'commons.search'"
        ></widgets-trends-legend>
    </div>
  </div>
</div>

<div class="explain" *ngIf="trendSelected==='totalPrice'" >
  * {{'inter-chain.prestay.explain_usd' | translate }}
</div>

<div class="align-center">
  <mh-spinner-classic [hidden]="!waiting"></mh-spinner-classic>
</div>

<ng-container *ngIf="!waiting">
  <div class="content_graph" style="display: block;">
    <canvas baseChart
      (chartClick)="chartClicked($event)"
      [data]="chartData"
      [options]="lineChartOptions"
      [plugins]="lineChartPlugins"
      [type]="lineChartType"></canvas>
  </div>

  <div class="content-table">
    <widget-trends-table #tableTrend
      (detailSelected)="emitDetailSelected($event)"
      [formatScore] = "['note','ranking_areas'].includes(trendSelected)"
      [showDetail]="showDetail"
      [firstColumn]="firstColumn"
      [trendSelected]="trendSelected"
      [lineChartData]="lineChartDataTable"
      [hideTotalRow]="hideTotalRow"
      [lineChartLabels]="lineChartLabels"
      [weightedAverageData]="weightedAverageData">
    <ng-content></ng-content>
    </widget-trends-table>
  </div>

</ng-container>
